import { FC } from 'react';
import { CgDollar } from 'react-icons/cg';
import { Text } from '@chakra-ui/react';

import {
  convertToType,
  divideByOneHundred,
  preserveEmpty,
  timesOneHundred,
} from '~/core/application/workflow/utils/transformFuncs';
import { WorkflowStepFormFieldNumberInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const CurrencyFieldToBlock: FieldToBlock<
  'currency',
  WorkflowStepFormFieldNumberInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'number-input',
  transformFuncsIn: [divideByOneHundred, (value: number) => value.toFixed(2)],
  transformFuncsOut: [
    preserveEmpty(convertToType('number')),
    preserveEmpty(timesOneHundred),
  ],
  componentProps: {
    startElement: <CgDollar />,
    decimalPlaces: 2,
    disabled: field.disabled ?? false,
    size: 'sm',
  },
});

type CurrencyFieldValueProps = FieldValueProps<'currency'>;

export const CurrencyFieldValue: FC<CurrencyFieldValueProps> = ({ field }) => {
  const value = divideByOneHundred(field.value ?? 0).toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  return <Text>${value}</Text>;
};
